/**
 * RISK: every id is a UUID of ~37 characters in the query string. Past a few dozen, one
 * request would approach the header size proxies accept, so the ids travel in chunks.
 */
export const IDS_PER_REQUEST = 40;

// Half the one-hour lifetime of the presigned logo links that channel and programme
// lookups carry, so a view shown again never paints links about to expire.
export const BY_IDS_LIFETIME = 30 * 60 * 1000;

export function normalizeIds(ids: readonly string[]): string[] {
  return [...new Set(ids)].sort();
}

export function normalizePresentIds(ids: readonly (string | null | undefined)[]): string[] {
  return normalizeIds(ids.filter((id): id is string => !!id));
}

export function chunk<T>(items: readonly T[], size: number): T[][] {
  return Array.from({ length: Math.ceil(items.length / size) }, (_, index) =>
    items.slice(index * size, index * size + size)
  );
}

export function requestInChunks<TResponse>(
  ids: readonly string[],
  request: (ids: string[]) => Promise<TResponse>
): Promise<TResponse[]> {
  return Promise.all(chunk(ids, IDS_PER_REQUEST).map(request));
}
